<template>
  <div class="text-sign-mask" @click.self="closeSign">
    <div class="text-sign-panel">
      <div class="text-sign-panel__handle"></div>
      <div class="text-sign-panel__head">
        <div>
          <div class="text-sign-panel__title">选择签名样式</div>
          <div class="text-sign-panel__sub">根据姓名自动生成，无需手写</div>
        </div>
        <button type="button" class="text-sign-panel__close" @click="closeSign">
          <i class="el-icon-close"></i>
        </button>
      </div>

      <div class="text-sign-panel__name">
        <label>签署人姓名</label>
        <el-input
          v-model="editName"
          maxlength="20"
          placeholder="请输入真实姓名"
          @input="onNameChange"
        />
      </div>

      <div v-if="loadingFonts" class="text-sign-panel__loading">签名样式加载中...</div>
      <div v-else-if="!editName.trim()" class="text-sign-panel__empty">请先填写姓名以预览签名</div>
      <div v-else class="text-sign-panel__list">
        <div
          v-for="item in previews"
          :key="item.id"
          class="text-sign-item"
          :class="{ active: selectedId === item.id }"
          @click="selectedId = item.id"
        >
          <div class="text-sign-item__meta">
            <span class="text-sign-item__label">{{ item.label }}</span>
            <span v-if="selectedId === item.id" class="text-sign-item__check">
              <i class="el-icon-check"></i>
            </span>
          </div>
          <div class="text-sign-item__preview">
            <img :src="item.dataUrl" alt="签名预览" />
          </div>
        </div>
      </div>

      <div class="text-sign-panel__foot">
        <button type="button" class="text-sign-btn text-sign-btn--ghost" @click="closeSign">
          取消
        </button>
        <button
          type="button"
          class="text-sign-btn text-sign-btn--primary"
          :disabled="!canConfirm"
          @click="handleConfirm"
        >
          使用此签名
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ensureSignFonts,
  generateAllTextSignatures,
} from '../../utils/textSign'

export default {
  name: 'SignImg',
  props: {
    showFunction: {
      type: Function,
      default: null,
    },
    signSuccess: {
      type: Function,
      default: null,
    },
    signerName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editName: '',
      selectedId: 'xingkai',
      previews: [],
      loadingFonts: true,
      debounceTimer: null,
    }
  },
  computed: {
    canConfirm() {
      return !!this.editName.trim() && this.previews.length > 0 && !this.loadingFonts
    },
  },
  mounted() {
    this.editName = String(this.signerName || '').trim()
    this.bootstrap()
  },
  beforeDestroy() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  },
  methods: {
    async bootstrap() {
      this.loadingFonts = true
      try {
        await ensureSignFonts()
      } finally {
        this.loadingFonts = false
        this.refreshPreviews()
      }
    },
    onNameChange() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.refreshPreviews()
      }, 180)
    },
    refreshPreviews() {
      const name = this.editName.trim()
      if (!name) {
        this.previews = []
        return
      }
      try {
        this.previews = generateAllTextSignatures(name)
        if (!this.previews.find((p) => p.id === this.selectedId)) {
          this.selectedId = this.previews[0].id
        }
      } catch (e) {
        console.error(e)
        this.previews = []
      }
    },
    closeSign() {
      if (this.showFunction) this.showFunction()
    },
    handleConfirm() {
      const picked = this.previews.find((p) => p.id === this.selectedId)
      if (!picked) {
        alert('请选择一种签名样式')
        return
      }
      if (this.signSuccess) {
        this.signSuccess(picked.dataUrl, false, this.editName.trim())
      }
    },
  },
}
</script>

<style scoped>
.text-sign-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(17, 24, 39, 0.42);
}

.text-sign-panel {
  width: 100%;
  max-width: 480px;
  max-height: 88vh;
  overflow: auto;
  padding: 8px 16px 18px;
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  background: #fff;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 -12px 36px rgba(15, 23, 42, 0.14);
}

.text-sign-panel__handle {
  width: 36px;
  height: 4px;
  margin: 4px auto 12px;
  background: #e5e7eb;
  border-radius: 4px;
}

.text-sign-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.text-sign-panel__title {
  font-size: 17px;
  font-weight: 650;
  color: #1f2329;
}

.text-sign-panel__sub {
  margin-top: 4px;
  font-size: 12px;
  color: #8f959e;
}

.text-sign-panel__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 16px;
  cursor: pointer;
}

.text-sign-panel__name label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
}

.text-sign-panel__name ::v-deep .el-input__inner {
  height: 42px;
  border-radius: 10px;
  border-color: #e5e7eb;
  background: #f9fafb;
}

.text-sign-panel__name ::v-deep .el-input__inner:focus {
  border-color: #e4572e;
  background: #fff;
}

.text-sign-panel__loading,
.text-sign-panel__empty {
  padding: 40px 0;
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
}

.text-sign-panel__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.text-sign-item {
  padding: 12px;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  background: #fafbfc;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.text-sign-item.active {
  border-color: rgba(228, 87, 46, 0.55);
  background: #fff8f5;
  box-shadow: 0 0 0 3px rgba(228, 87, 46, 0.1);
}

.text-sign-item__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.text-sign-item__label {
  font-size: 12px;
  font-weight: 500;
  color: #8f959e;
}

.text-sign-item__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e4572e;
  color: #fff;
  font-size: 11px;
}

.text-sign-item__preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 68px;
  padding: 10px 12px;
  background: #fff;
  border-radius: 8px;
  border: 1px dashed #eceef2;
}

.text-sign-item__preview img {
  max-width: 100%;
  max-height: 72px;
  object-fit: contain;
}

.text-sign-panel__foot {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.text-sign-btn {
  flex: 1;
  height: 46px;
  border: none;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 560;
  cursor: pointer;
}

.text-sign-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.text-sign-btn--ghost {
  color: #4b5563;
  background: #f3f4f6;
}

.text-sign-btn--primary {
  flex: 1.3;
  color: #fff;
  background: linear-gradient(135deg, #f06a45 0%, #e4572e 100%);
  box-shadow: 0 8px 18px rgba(228, 87, 46, 0.28);
}
</style>
